import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { map, Observable, tap } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { Injectable } from "@angular/core";
import { DocumentDto, MsisdnDto, PropertyDto, ResultListDto, SearchResultDocumentDto, SearchResultMsisdnDto, SubscriberFullDto } from "./dto";

@Injectable({
	providedIn: 'root'
})
export class HttpPropertyService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/property', authService);
	}

	getAll(): Observable<PropertyDto[]> {
		return super.doGet(true, `/`);
	}
	saveProperties(input: PropertyDto[]): Observable<PropertyDto[]> {
		return super.doPost(true, '/', input);
	}
}
